export enum ProfileActionType {
    SET_PROFILE = 'SET_PROFILE'
}